import React from 'react';
import PropTypes from 'prop-types';
import { TicketFooterRow } from '../TicketFooter';

function NikyStateNg({ nikyStake, nikyWin, nikyOdds }) {
    if (!nikyStake) {
        return null;
    }

    return (
        <>
            <TicketFooterRow rowTitle="ticketus.ticket.extras.nikyStake" rowInfo={nikyStake} />
            <TicketFooterRow rowTitle="ticketus.ticket.extras.nikyOdds" rowInfo={nikyOdds} />
            <TicketFooterRow rowTitle="ticketus.ticket.extras.nikyWin" rowInfo={nikyWin} />
        </>
    );
}

NikyStateNg.propTypes = {
    nikyStake: PropTypes.number,
    nikyWin: PropTypes.number,
    nikyOdds: PropTypes.number
};

export default NikyStateNg;
